﻿import FFInstructionTypePage from "./ffInstructionTypePage";
import FFRemindersPage from "./ffRemindersPage";
import FFPortfolioReviewPage from "./ffPortfolioReviewPage";
import FFInstructionsPage from "./ffInstructionsPage";

if (!window.ffInstructionTypePage) {
    window.ffInstructionTypePage = new FFInstructionTypePage();
}

if (!window.ffRemindersPage) {
    window.ffRemindersPage = new FFRemindersPage();
}

if (!window.ffPortfolioReviewPage) {
    window.ffPortfolioReviewPage = new FFPortfolioReviewPage();
}

if (!window.ffInstructionsPage) {
    window.ffInstructionsPage = new FFInstructionsPage();
}


